import React from 'react';
import { ThingToDoComponent, ThingToDoComponentProps } from '@apps/guest/packages/layout-engine/widgets/Custom/components/ThingToDo/ThingToDoComponent';
import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import { DesignLayoutType, useGetThingsToDoContainersQuery } from '@graphql/generated';
import { Box, Flex } from '@withjoy/joykit';
import { useLayout } from '@apps/guest/packages/layout-engine/layouts/LayoutProvider';
import { Skeleton } from '@shared/components/Skeleton';

// Tip:
// This is the component that is rendered on the guest site.
export const DefaultThingsToDoGuest = (props: GuestSiteComponentProps) => {
  const { data, loading } = useGetThingsToDoContainersQuery({ fetchPolicy: 'cache-first', batchMode: 'fast', variables: { payload: { eventId: props.data.eventId } } });
  const defaultThingsToDo = data?.getThingsToDoContainers;
  const { layout } = useLayout();
  const componentDefaultLayout = layout === DesignLayoutType.brannan ? 'fullRow' : 'widget';
  return (
    <>
      {loading ? (
        <>
          <LoadingSkeleton />
          <LoadingSkeleton />
        </>
      ) : (
        defaultThingsToDo &&
        defaultThingsToDo.length > 0 &&
        defaultThingsToDo.slice(0, 3).map(container => {
          const data: ThingToDoComponentProps = {
            id: container.id,
            title: container.content.poi.title,
            category: container.content.poi.category,
            description: container.content.poi.description,
            image: container.content.poi.image,
            url: container.content.poi.url,
            sortOrder: 0,
            tours: container.content.poi.tours.length > 3 ? container.content.poi.tours.slice(0, 3) : container.content.poi.tours,
            location: container.content.location.city || undefined,
          };
          return (
            <Box
              key={container.id}
              width="100%"
            >
              <ThingToDoComponent
                {...data}
                designType={componentDefaultLayout}
              />
            </Box>
          );
        })
      )}
    </>
  );
};

const LoadingSkeleton = () => {
  return (
    <Flex
      flexDirection={['column', 'row']}
      width="100%"
      gap={['24px', '32px']}
      alignItems={['stretch', 'flex-start']}
    >
      <Box
        width="100%"
        maxWidth={['100%', '440px']}
      >
        <Skeleton
          width="100%"
          height={['180px', '216px']}
          borderRadius={4}
        />
      </Box>
      <Box
        width="100%"
        maxWidth={['100%', '352px']}
        display="flex"
        flexDirection="column"
        gap={'8px'}
      >
        {[1, 2, 3].map(i => (
          <Flex
            key={i}
            alignItems="flex-start"
            gap={['12px', '16px']}
            marginBottom={['16px', '24px']}
          >
            <Skeleton
              width={50}
              height={50}
              borderRadius={4}
            />
            <Flex
              flexDirection="column"
              gap={1}
              flex="1"
            >
              <Skeleton
                width="80%"
                height={15}
                borderRadius={4}
              />
              <Skeleton
                width="60%"
                height={15}
                borderRadius={4}
              />
              <Skeleton
                width="70%"
                height={15}
                borderRadius={4}
              />
            </Flex>
          </Flex>
        ))}
      </Box>
    </Flex>
  );
};
